export enum ChatStatus {
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum ChatMode {
  SMS = "SMS",
  PATIENT_PORTAL = "PATIENT_PORTAL",
}
